import { isEmpty } from "lodash";

import { Dislike, Favourite, Ignore, Like } from "../components";
import ThumbNail from "../components/thumbNail/ThumbNail";

import styles from "./config.module.scss";

export const columns = [
  {
    field: "id",
    renderCell: (row) => (
      <ThumbNail
        name={row.title}
        color={row.color}
        imgSrc={row.thumbnail_img}
        hasImage={!isEmpty(row.thumbnail_img)}
      />
    ),
    className: styles.image,
  },
  {
    field: "title",
    headerName: "Song",
    rowClassName: styles.title,
  },
  {
    field: "artist_name",
    headerName: "Artist",
  },
  {
    field: "like",
    // headerName: "Like",
    renderCell: (row) => <Like row={row} />,
    className: styles.like,
  },
  {
    field: "dislike",
    // headerName: "Dislike",
    renderCell: (row) => <Dislike row={row} />,
    className: styles.dislike,
  },
  {
    field: "favorite",
    headerName: "Favorite",
    renderCell: (row) => <Favourite row={row} />,
    className: styles.favorite,
  },
  {
    field: "ignore",
    headerName: "Ignore",
    renderCell: (row) => <Ignore row={row} />,
    className: styles.ignore,
  },
];
